import { Button } from "antd";
import React from "react";

function Item({ title = "", path = "" }) {
	return (
		<div className="item">
			<div className="row-item">
				<div className="holder-icon">
					<div className="box-icon">
						<i className="icon-post-box"></i>
					</div>
				</div>
				<div className="holder-title-notifi">
					<span className="date-category">{title}</span>
				</div>
				<div className="holder-action">
					<div className="holder-button">
						<Button type="link" onClick={() => {}} download href={process.env.PUBLIC_URL + path} className="btn-normal btn-nrm">
							دانلود فایل
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Item;
